import EcommerceMetrics from "../../components/ecommerce/EcommerceMetrics";
import MonthlySalesChart from "../../components/ecommerce/MonthlySalesChart";
import StatisticsChart from "../../components/ecommerce/StatisticsChart";
import MonthlyTarget from "../../components/ecommerce/MonthlyTarget";
import RecentOrders from "../../components/ecommerce/RecentOrders";
import DemographicCard from "../../components/ecommerce/DemographicCard";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import { client } from "../../sdkAdapter";

export default function Home() {
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await client.getApiDashStats();
        // Handle response nesting: res.data.data or res.data
        const data = (res as any).data?.data || (res as any).data;
        if (data) {
          setStats(data);
        }
      } catch (err) {
        console.error("Failed to fetch dash stats:", err);
      }
    };
    fetchStats();
  }, []);

  if (!stats) return <div className="p-6">Loading dashboard...</div>;

  return (
    <>
      <PageMeta
        title="React.js Ecommerce Dashboard | Shoplattice Admin - React.js Admin Dashboard Template"
        description="This is React.js Ecommerce Dashboard page for Shoplattice Admin - React.js Tailwind CSS Admin Dashboard Template"
      />
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-12 space-y-6 xl:col-span-7">
          <EcommerceMetrics
            customers={stats.customers || { value: 0, growth: 0, isUp: true }}
            orders={stats.orders_metrics || { value: 0, growth: 0, isUp: true }}
            revenue={stats.revenue || { value: "$0.00", growth: 0, isUp: true }}
            products={stats.products_metrics || { value: 0, growth: 0, isUp: true }}
          />
          <MonthlySalesChart series={stats.monthlySales || []} />
        </div>

        <div className="col-span-12 xl:col-span-5">
          <MonthlyTarget
            series={stats.monthlyTarget || [0]}
            targetMetrics={stats.target_metrics}
          />
        </div>

        <div className="col-span-12">
          <StatisticsChart series={stats.statistics || []} />
        </div>

        <div className="col-span-12 xl:col-span-5">
          <DemographicCard demographics={stats.demographics} />
        </div>

        <div className="col-span-12 xl:col-span-7">
          <RecentOrders orders={stats.recentOrders || []} />
        </div>
      </div>
    </>
  );
}
